import { useNavigate } from 'react-router-dom';
export const ExperiencedServices = () => {
  const services = [
    {
      icon: '/maintenance.png',
      title: 'Building Maintenance',
      link: '/building-maintenance',
      desc: 'Comprehensive maintenance to ensure your property remains in top condition.',
    },
    {
      icon: '/smallrepair.png',
      title: 'Small Repairs',
      link: '/small-repairs',
      desc: 'Quick and efficient repair solutions for minor damages and fixes.',
    },
    {
      icon: '/refurbish.png',
      title: 'Refurbishment of Flats',
      link: '/flat-refurbishment',
      desc: 'Complete refurbishment services to modernize and upgrade flats.',
    },
    {
      icon: '/painting.png',
      title: 'Painting',
      link: '/painting-services',
      desc: 'Interior and exterior painting with high-quality finishes.',
    },
    {
      icon: '/plumbing.png',
      title: 'Plumbing',
      link: '/plumbing-services',
      desc: 'Professional plumbing services for installations, leaks, and repairs.',
    },
    {
      icon: '/electricalwork.png',
      title: 'Electrical Works',
      link: '/electrical-works',
      desc: 'Safe and reliable electrical installations and maintenance.',
    },
    {
      icon: '/gardening.png',
      title: 'Gardening',
      link: 'gardening-services',
      desc: 'Garden maintenance and beautification for your outdoor spaces.',
    },
    {
      icon: '/roofing.png',
      title: 'Roofing',
      link: '/roofing-services',
      desc: 'Durable and weatherproof roofing installation and repair services.',
    },
    {
      icon: '/cleaning.png',
      title: 'Cleaning',
      link: '/cleaning-services',
      desc: 'Professional cleaning services for residential and commercial properties.',
    },
    {
      icon: '/carpet.png',
      title: 'Carpets and Flooring',
      link: '/flooring-services',
      desc: 'Installation and restoration of all types of flooring and carpets.',
    },
    {
      icon: '/homeextension.png',
      title: 'Home Extensions',
      link: '/home-extensions',
      desc: 'Expand your home with seamless and stylish extensions.',
    },
    {
      icon: '/kitchenfitting.png',
      title: 'Kitchen Fittings',
      link: '/kitchen-fitting-services',
      desc: 'Custom kitchen fitting services with attention to detail.',
    },
    {
      icon: '/bath.png',
      title: 'Bathroom Fittings',
      link: '/bathroom-fittings',
      desc: 'Elegant and functional bathroom installation and design.',
    },
    {
      icon: '/tiling.png',
      title: 'Tiling',
      link: '/tiling-services',
      desc: 'Expert tiling for walls, floors, and decorative finishes.',
    },
    {
      icon: '/groundwork.png',
      title: 'Ground Works',
      link: '/groundwork-services',
      desc: 'Reliable groundwork solutions to prepare for any construction project.',
    },
    {
      icon: '/landscaping.png',
      link: '/landscaping-service',
      title: 'Gardening & Landscaping',
      desc: 'Transform outdoor areas with creative landscaping and garden design.',
    },
  ];
  let navigate = useNavigate();
  return (
    <>
      <div className="w-full">
        <div className="flex w-full justify-center bg-[#121212] pb-[4rem] font-inter">
          <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-center justify-center gap-y-[4rem] px-[2rem] font-[700] text-[#f97316]">
            <div className="w-full md:w-[33%] lg:w-[33%]">
              <h1
                style={{
                  WebkitTextStroke: '0.2rem #f97316',
                }}
                className="w-full text-center text-[4rem] text-[#fff4f0] md:text-[7rem] lg:text-[10rem]"
              >
                3<span className="mt-[-0.5rem]">+</span>
              </h1>
              <h1 className="w-full text-center text-[1.8rem] md:text-[2rem] lg:text-[2.2rem]">
                Years of Experiences
              </h1>
            </div>
            <div className="w-full md:w-[33%] lg:w-[33%]">
              <h1
                style={{
                  WebkitTextStroke: '0.2rem #f97316',
                }}
                className="w-full text-center text-[4rem] text-[#fff4f0] md:text-[7rem] lg:text-[10rem]"
              >
                1.1K
              </h1>
              <h1 className="w-full text-center text-[1.8rem] md:text-[2rem] lg:text-[2.2rem]">
                Completed Projects{' '}
              </h1>
            </div>
            <div className="w-full md:w-[33%] lg:w-[33%]">
              <h1
                style={{
                  WebkitTextStroke: '0.2rem #f97316',
                }}
                className="w-full text-center text-[4rem] text-[#fff4f0] md:text-[7rem] lg:text-[10rem]"
              >
                3<span className="mt-[-0.5rem]">+</span>
              </h1>
              <h1 className="w-full text-center text-[1.8rem] md:text-[2rem] lg:text-[2.2rem]">
                Awards & Recognitions{' '}
              </h1>
            </div>
          </div>
        </div>{' '}
      </div>{' '}
      <div className="flex w-full justify-center bg-white py-[4rem] font-inter">
        <div className="flex w-full max-w-[144rem] flex-col items-stretch justify-center gap-[4rem] px-[2rem]">
          {/* ===== HEADING ===== */}
          <div className="flex flex-col items-center text-center">
            <h1 className="mt-[1rem] hidden text-[2.4rem] font-[700] leading-[4rem] text-[#121212] sm:block md:text-[3.2rem] lg:text-[4rem] lg:leading-[5.5rem]">
              Discover What KU Contractors Limited <br /> Offers You
            </h1>
            <h1 className="mt-[1rem] text-[2.4rem] font-[700] leading-[4rem] text-[#121212] sm:hidden md:text-[3.2rem] lg:text-[4rem] lg:leading-[5.5rem]">
              Discover What KU Contractors Limited Offers You
            </h1>
          </div>

          {/* ===== SMALL SERVICES GRID ===== */}
          <div className="mt-[2rem] grid w-full grid-cols-1 gap-[2rem] sm:grid-cols-2 md:mt-[3rem] md:grid-cols-3 lg:mt-[4rem] lg:grid-cols-4">
            {services.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  navigate(item.link);
                }}
                className="flex cursor-pointer flex-col items-center justify-start gap-3 rounded-xl border border-[#e5e5e5] bg-[#fafafa] p-6 text-center transition"
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="h-[5rem] w-[5rem] object-contain"
                />
                <h3 className="text-[1.8rem] font-semibold text-[#1C253C]">{item.title}</h3>
                <p className="text-[1.4rem] text-[#555]">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
